export enum EventType {
  CTA_CLICK = 'cta_click',
  LOGIN = 'login',
  LOGOUT = 'logout',
  MENU_CLICK = 'menu_click',
  SELECT_ITEM = 'select_item',
}
